import { inject } from '@angular/core';
import { HttpRequest, HttpInterceptorFn } from '@angular/common/http';
import { IContextServiceToken } from '../services/infrastructure/context/context-service.interface';


// eslint-disable-next-line @typescript-eslint/naming-convention
export const httpShopContextInterceptor: HttpInterceptorFn = (req, next) => {
  let shopContext = inject(IContextServiceToken).contextGet();

  let modifiedRequest = req;

  if (shopContext) {
    modifiedRequest = shopContextHeaderSet(req, shopContext);
  }

  return next(modifiedRequest);
};

function shopContextHeaderSet(req: HttpRequest<unknown>, shopContext: string) {
  return req.clone({
    headers: req.headers.set('ShopContext', shopContext),
  });
}
